module.exports = __webpack_public_path__ + "static/media/trc.07a4dd67.png";